import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "/employee";

export type listType = {
  search?: string;
  nationality?: string | number;
  gender?: string;
  position?: number;
  department?: number;
  status?: string;
  sortType?: string;
  sortBy?: string;
  limit?: number;
  page?: number;
};

export type researchAndArticleForm = {
  id_article: number | null;
  article_title: string;
  article_detail: string;
  status: string;
  article_type: string;
  is_publish: number // 0,1
}
export type delete_research_and_article = {
  id_article: number | null;
  status: string;
}

export type update_is_public = {
  article_type: string;
  is_publish: boolean;
}

export type award_data = {
  id_employee_award: number | null;
  award_name: string;
  desc: string;
  agency: string;
  link: string;
  status: string;
}
export type award_delete_data_type = {
  id_employee_award: number;
  status: string;
}

export interface list_articles_and_research extends listType {
  article_type: string;
}
export interface list_award extends listType {
}
export interface list_employee_booking_meeting_room extends pagination_list {
  keyword?: string
}

export class EmployeeApi extends BaseAPI {
  static list(query: listType, token?: string): Promise<any> {
    if (!token) {
      return this.api.get(`${path}/list`, {
        params: { ...query },
      });
    } else {
      return this.api.get(`${path}/list`, {
        params: { ...query },
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }
  static getOne(id: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id}/get-one`);
  }
  static getOneForExport(id: number, token: string): Promise<any> {
    return this.api.get(`${path}/${id}/get-one`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  static updated(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/updated`, body);
  }
  static create(body: any): Promise<any> {
    return this.api.post(`${path}/create`, body);
  }
  static updateStatusOnline(id_employee: number): Promise<any> {
    return this.api.patch(`${path}/${id_employee}/status_employee`);
  }
  static uploadEmployee(formId: number, file: FormData): Promise<any> {
    return this.api.post(`${path}/upload/employee/${formId}`, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static uploadEducation(formId: number, file: FormData): Promise<any> {
    return this.api.post(`${path}/upload/education/${formId}`, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static uploadTraining(formId: number, file: FormData): Promise<any> {
    return this.api.post(`${path}/upload/training/${formId}`, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static uploadBackground(formId: number, file: FormData): Promise<any> {
    return this.api.post(`${path}/upload/background/${formId}`, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static deleteEmployee(id_employee: number): Promise<any> {
    return this.api.delete(`${path}/${id_employee}`);
  }

  static deleteFile(
    id_file: number,
    type: "education" | "training" | "background" | "avatar"
  ): Promise<any> {
    return this.api.delete(`${path}/file/${id_file}`, {
      params: { type: type },
    });
  }
  static downloadFile(
    id: number,
    type: "avatar" | "education" | "training" | "background"
  ): Promise<any> {
    return this.api.get(`${path}/file/download/${id}`, {
      responseType: "arraybuffer",
      params: { type: type },
    });
  }

  static updateHistoryDetail(
    id: number,
    type: "education" | "training" | "work_history",
    data: any
  ): Promise<any> {
    return this.api.patch(`${path}/update-detail/${id}`, data, {
      params: { type: type },
    });
  }
  static deleteHistoryDetail(
    id: number,
    type: "education" | "training" | "work_history"
  ): Promise<any> {
    return this.api.delete(`${path}/detail/${id}`, { params: { type: type } });
  }
  static resetPassword(
    id_employee: number,
    body: {
      new_password: string;
      confirm_password: string;
    }
  ): Promise<any> {
    return this.api.patch(`${path}/${id_employee}/reset-password`, body);
  }
  static checkEmail(email: string): Promise<any> {
    return this.api.post(`${path}/check-email`, { email_organization: email });
  }
  static export_pdf(id_employee: number, token: string): Promise<any> {
    return this.api.get(`${path}/${id_employee}/pdf/${token}`, {
      responseType: "arraybuffer",
    });
  }

  static upsertResearchAndArticles(id_employee: number, body: researchAndArticleForm[]): Promise<AxiosResponse> {
    return this.api.put(`${path}/${id_employee}/article`, body)
  }
  static listArticlesResearch(id_employee: number, params: list_articles_and_research): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_employee}/list/article-research`, { params })
  }
  static deleteArticleAndResearch(id_employee: number, body: delete_research_and_article[]): Promise<AxiosResponse> {
    return this.api.put(`${path}/${id_employee}/article`, body)
  }
  static updateIsPublicArticleAndResearch(id_employee: number, body: update_is_public): Promise<AxiosResponse> {
    return this.api.patch(`${path}/${id_employee}/public-article`, body)
  }
  static findOneArticle(id_article: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-one/article/${id_article}`)
  }

  static upsertAwardData(id_employee: number, body: award_data[]): Promise<AxiosResponse> {
    return this.api.put(`${path}/${id_employee}/award`, body)
  }
  static deleteAward(id_employee: number, body: award_delete_data_type[]): Promise<AxiosResponse> {
    return this.api.put(`${path}/${id_employee}/award`, body)
  }
  static listAward(id_employee: number, params: list_award): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_employee}/list/award`, { params })
  }
  static uploadCvFile(id_employee: number, file: FormData): Promise<AxiosResponse> {
    return this.api.post(`${path}/upload/background-file-cv/${id_employee}`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static findOneCvFile(id_employee: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_employee}/get-one/cv`)
  }
  static deleteBackgroundFile(id_background_file: number): Promise<AxiosResponse> {
    return this.api.delete(`${path}/background-file/${id_background_file}`)
  }
  static downloadCvFile(id_background_file: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/file/download/${id_background_file}`, {
      params: { type: "background" },
      responseType: "arraybuffer"
    })
  }


  static listActiveEmployee(params: list_employee_booking_meeting_room): Promise<AxiosResponse> {
    return this.api.get(`${path}/list-employee/booking-meeting-room`, { params });
  }
}
